import SecondTitle from "./SecondTitle";
export default SecondTitle;
